export default __webpack_public_path__ + "static/media/icon-network-tron.0b279700.svg";